import './vendor';
import {enableProdMode, provideZoneChangeDetection} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {AppModule} from './app';
import {environment} from './environments/environment';

if (environment.production) {
  enableProdMode();
}

const p = platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], });
p.then(() => {
  (<any> window).appBootstrap && (<any> window).appBootstrap();
});
// .catch(err => console.error(err));
